import type { ApiOptions, ApiResponse, IResponse } from './api/interfaces/api';
import { Errors } from './error.enum';

export const useApi = async <T>(
  path: string,
  { body = null, method = 'GET', ...options }: ApiOptions = {}
): Promise<ApiResponse<T>> => {
  try {
    const response = await $fetch<IResponse<T>>(path, {
      method,
      ...(body && { body }),
      ...options,
    });
    return {
      data: response.result,
      error: null,
    };
  } catch (err: unknown) {

    const authStore = useAuthStore();
    if (!authStore.profile && (err as any)?.status === 401) {
      authStore.setShowNeedLogin(true);
    }

    const errorMessage =
      (err as { data?: { data?: { message?: string } } })?.data?.data
        ?.message || '';
    
    const finalErrorMessage = Object.values(Errors).includes(errorMessage as Errors) ? errorMessage : Errors.INTERNAL_ERROR;
    return {
      data: null,
      error: finalErrorMessage,
    };
  }
};
